// Set measurement (and diagnostics) text to given tspans
import { status } from "../../../../theme/muiTheme";

export function updateMeasurementsText(data, measurementsTag, svgRoot) {
    var tspans = svgRoot?.querySelectorAll(measurementsTag+' tspan');
    if ((tspans === undefined) || (!tspans?.length) || (!data)) {
      // console.warn("Expected tspans and measurements to be arrays and defined");
      return;
    }
  
    // Reverse the tspans array before iterating over it (this is needed to populate the measurements correctly to UI)
    const reversedTspans = [...tspans].reverse();
  
    let idx = 0;
    // Set measurements to <tspans> elements
    for (const tspan of reversedTspans) {
      try {
        if (idx < data.length) {
          const item = data[idx++];
          // Special cases, Text
          switch (item.displayName) {
            case "Water Level": { tspan.innerHTML = `${item.value ?? ""}`; } break; //TODO: check if this special case can be avoided
            default: { tspan.innerHTML = `${item.displayName ?? ""}:  ${item.value ?? ""} ${item.unit ?? ""}`; }
          }
          // set text color of measurements with active alarms to red
          if (item.isAlarmActive) {
            if (item.category === "SampleCondition" || item.category === "Device") { tspan.style.fill = status.errorAlt;}
            if (item.category === "Warning") { tspan.style.fill = status.warning;}
            if (item.category === "Normal") { tspan.style.fill = "#fff";}
          }
          // Special cases, Styles
          if (item.valueName === "ScrubberWaterLevel") {
            const waterContainer = svgRoot?.querySelector('#scrubber-waterContainer');
            if (waterContainer !== undefined) {
              item.isAlarmActive ? waterContainer.setAttribute("class", "water-level-alert") : waterContainer.setAttribute("class", "");
            }
          }
        } else {
          tspan.innerHTML = "";
        }
      } catch (error) {
        console.error("Error updating tspan content in useMeasurementTextEffect:", error);
      }
    }
  }

// Set alarm-active class to devices with active alarms.
// Gives class attribute to a spesific device card
export function updateDeviceAlarmEffects(deviceTag, deviceBgColorProp, svgRoot) {
    const deviceBgColor = deviceBgColorProp == null ? 'grey' : deviceBgColorProp;
    var deviceElement = svgRoot?.querySelector(deviceTag);
    const iconAlarm = deviceElement?.querySelector('[id^="icon-alarm"]');
    const cardRect = deviceElement?.querySelectorAll('rect');
  
    if (!deviceElement) {
      // console.warn("updateDeviceAlarmEffects: No deviceContainer supplied.");
      return;
    }
    if (!cardRect) {
      // console.warn("updateDeviceAlarmEffects: No cardRect found.");
      return;
    }
  
    try {
      if (deviceBgColor !== "red") {
        cardRect[0].classList.remove(...cardRect[0].classList);
        iconAlarm?.classList.remove(...iconAlarm.classList);
        return;
      }
      // default alarm styles
      cardRect[0].setAttribute("class", "alarm-active");
      iconAlarm.setAttribute("class", "alarm-active");
    } catch (error) {
      console.error("Error updating device alarm effect:", error);
    }
  }
  
// Function to append additional text to filter ids and update references
export const appendTextToFilterIds = (svgRoot, additionalText) => {
    if (!svgRoot) {
      console.warn("appendTextToFilterIds: svgRoot is not available.");
      return;
    }
  
    // Select all <filter> elements in the SVG
    const filters = svgRoot.querySelectorAll('filter');
  
    // Modify their `id` attributes and update references
    filters.forEach(filter => {
      const currentId = filter.getAttribute('id');
      const newId = `${currentId}${additionalText}`;
      filter.setAttribute('id', newId);
  
      const referencingElements = svgRoot.querySelectorAll(`[filter="url(#${currentId})"]`);
      referencingElements.forEach(element => {
        element.setAttribute('filter', `url(#${newId})`);
      });
    });
  };